// next-app/src/components/survey/email-opt-in.tsx
'use client';

import { FormCheckbox } from '@/components/form/form-checkbox';

interface EmailOptInProps {
  optInText?: string;
  disabled?: boolean;
}

const DEFAULT_OPT_IN_TEXT =
  'Yes, I would like to receive news, special offers, and information about Lincoln vehicles and events via email.';

/**
 * Email opt-in checkbox for surveys.
 */
export function EmailOptIn({ optInText = DEFAULT_OPT_IN_TEXT, disabled }: EmailOptInProps) {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">Stay Connected</h2>

      <FormCheckbox
        name="email_opt_in"
        label="Email Preferences"
        checkboxText={optInText}
        disabled={disabled}
      />
    </div>
  );
}
